module.exports = __webpack_public_path__ + "img/user_upload_task.ae3319a9.svg";